import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";
import {AUTH_TIPE} from "../constants/AuthConstant";

const  pegawai_shiftShiftService = {}

pegawai_shiftShiftService.data = function (token,data='') {
    return fetch({
        url: '/transaksi/pegawai_shift/data',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

pegawai_shiftShiftService.show = function (token,data='') {
    return fetch({
        url: '/transaksi/pegawai_shift/show',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

pegawai_shiftShiftService.data_import = function (token,data) {
    return fetch({
        url: '/transaksi/pegawai_shift/data_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

pegawai_shiftShiftService.empty_import = function (token,data) {
    return fetch({
        url: '/transaksi/pegawai_shift/empty_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

pegawai_shiftShiftService.save_import = function (token,data) {
    return fetch({
        url: '/transaksi/pegawai_shift/save_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}


export default pegawai_shiftShiftService;
